import React, { Component, Fragment } from 'react';
import { isEmpty } from 'lodash';
import { gsap } from 'gsap';

import './style.css';

export default class NgGameRPGEASpices extends Component {

    componentDidMount = () => {
        const { id, spiceWidth, spiceHeight, x, y, duration = 0.6 } = this.props;
        const movedLenght = spiceHeight * 0.75;

        gsap.set(`.snowman_spice_${id}`, { left: x - (spiceWidth / 2), top: y - (spiceHeight / 2), opacity: 1 });
        gsap.fromTo(`#snowman_spice_${id}_1`, { rotate: 45 }, { translateY: -movedLenght * 0.7, translateX: movedLenght * 0.7, duration, yoyo: true, repeat: 1 })
        gsap.fromTo(`#snowman_spice_${id}_2`, { rotate: 90 }, { translateX: movedLenght * 1, duration, yoyo: true, repeat: 1 })
        gsap.fromTo(`#snowman_spice_${id}_3`, { rotate: 135 }, { translateY: movedLenght * 0.7, translateX: movedLenght * 0.7, duration, yoyo: true, repeat: 1 })
        gsap.fromTo(`#snowman_spice_${id}_4`, { rotate: -45 }, { translateY: -movedLenght * 0.7, translateX: -movedLenght * 0.7, duration, yoyo: true, repeat: 1 })
        gsap.fromTo(`#snowman_spice_${id}_5`, { rotate: -90 }, { translateX: -movedLenght * 1, duration, yoyo: true, repeat: 1 })
        gsap.fromTo(`#snowman_spice_${id}_6`, { rotate: -135 }, {
            translateY: movedLenght * 0.7, translateX: -movedLenght * 0.7, duration, yoyo: true, repeat: 1,
            onComplete: () => {
                this.props.killAnimation(id)
            }
        })
    }

    render() {
        const { id, spiceWidth } = this.props;
        return <Fragment key={`dgdddfg_${id}`}>
            <img id={`snowman_spice_${id}_1`} className={`snowman_spice snowman_spice_${id}`} style={{ width: spiceWidth }} src={`/../images/ver2/snowman/snowman/ice_spice.png`} />,
            <img id={`snowman_spice_${id}_2`} className={`snowman_spice snowman_spice_${id}`} style={{ width: spiceWidth }} src={`/../images/ver2/snowman/snowman/ice_spice.png`} />,
            <img id={`snowman_spice_${id}_3`} className={`snowman_spice snowman_spice_${id}`} style={{ width: spiceWidth }} src={`/../images/ver2/snowman/snowman/ice_spice.png`} />,
            <img id={`snowman_spice_${id}_4`} className={`snowman_spice snowman_spice_${id}`} style={{ width: spiceWidth }} src={`/../images/ver2/snowman/snowman/ice_spice.png`} />,
            <img id={`snowman_spice_${id}_5`} className={`snowman_spice snowman_spice_${id}`} style={{ width: spiceWidth }} src={`/../images/ver2/snowman/snowman/ice_spice.png`} />,
            <img id={`snowman_spice_${id}_6`} className={`snowman_spice snowman_spice_${id}`} style={{ width: spiceWidth }} src={`/../images/ver2/snowman/snowman/ice_spice.png`} />
        </Fragment>
    }
}